import { jsx } from 'react/jsx-runtime';
import { ChevronLeftIcon } from '@iris/react-icons/ChevronLeftIcon';
import { ChevronRightIcon } from '@iris/react-icons/ChevronRightIcon';
import { NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger } from '@radix-ui/react-navigation-menu';
import styles from './Pagination.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const PaginationButton = ({ totalPages, currentPage, direction, inverse, buildHref, onClick, }) => {
    const { iconContainer: iconContainerClasses, icon: iconClasses, iconLeft: iconLeftClasses, iconRight: iconRightClasses, button: buttonClasses, ring: ringClasses, } = styles({ inverse });
    const isNextButton = direction === "next";
    const newPage = currentPage + (isNextButton ? 1 : -1);
    if (isNextButton ? currentPage >= totalPages : currentPage <= 1) {
        return null;
    }
    const handleClick = (e) => {
        if ((isNextButton ? currentPage === totalPages : currentPage === 0) ||
            typeof onClick !== "function") {
            return;
        }
        onClick(newPage, e);
    };
    const Icon = isNextButton ? ChevronRightIcon : ChevronLeftIcon;
    const classNames = isNextButton ? iconRightClasses : iconLeftClasses;
    const buttonProps = {
        className: cn(buttonClasses(), ringClasses()),
        "aria-label": isNextButton ? "Go to Next Page" : "Go to Previous Page",
    };
    const buttonRootProps = {
        "aria-hidden": isNextButton ? currentPage >= totalPages : currentPage <= 1,
        href: undefined,
    };
    const ButtonComponent = buildHref !== undefined
        ? NavigationMenuLink
        : NavigationMenuTrigger;
    if (buildHref !== undefined) {
        buttonProps.href = buildHref(newPage);
    }
    return (jsx(NavigationMenuItem, Object.assign({}, buttonRootProps, { children: jsx(ButtonComponent, Object.assign({}, buttonProps, { onClick: handleClick, role: "link", "aria-controls": undefined, "data-state": undefined, "aria-expanded": undefined, children: jsx("span", { className: iconContainerClasses(), children: jsx(Icon, { className: cn(iconClasses(), classNames()) }) }) })) })));
};

export { PaginationButton };
